import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formateDateTime } from "../../../../services/date_service";
import { InputText } from "primereact/inputtext";
import * as Yup from "yup";
import classNames from "classnames";
import { Formik, useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import moment from "moment";
import * as XLSX from "xlsx";
import appUrl from "../../../config/appUrl";
import { FilterMatchMode } from "primereact/api";

const CashSummary = ({ onHide, getBoothList, addEditBooth, boothId }) => {
  const [dashList, setDashList] = useState([]);
  const [dashStat, setDashStat] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(0);
  const [totalFee, setTotalFee] = useState("");
  const [siteList, setSiteList] = useState([]);
  const [boothList, setBoothList] = useState("");
  const [booothId, setBooothId] = useState("");
  const [siteId, setSiteId] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [siteValue, setSitevalue] = useState(null);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [initialized, setInitialized] = useState(false);

  const date = new Date();

  let currentDate = moment(date).format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      boothId: "",
      fromDate: "",
      toDate: "",
      site: "",
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const getUserList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}user`);
      const data = await response.json();

      // Filter users with role 'login_user'
      const filteredUsers = data.filter((user) => user.role === "login_user");

      setUserList(filteredUsers);
      setFilteredUserList(filteredUsers); // Initially, set the filtered list to the entire list
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    // Count applied filters based on selected values
    const count = [
      formik.values.site,
      formik.values.boothId,
      fromDate,
      toDate,
    ].filter((val) => val).length;
    setAppliedFilters(count);
  }, [formik.values.site, formik.values.boothId, fromDate, toDate]);

  const getDashData = async () => {
    try {
      setLoading(true);
      setDashList([]); // ✅ Clear old data before new API call
      setTotalFee(0);   // ✅ Reset total as well


      const response = await fetch(
        `${appUrl.BASE_URL
        }parkingHistory/exportsummary?fromDate=${fromDate}&toDate=${toDate}&booth=${formik.values.boothId ? formik.values.boothId : ''
        }&site=${siteId ? siteId : ''}&user=${selectedUser ? selectedUser : ''
        }`
      );
      const data = await response.json();
      // const date = new Date(data?.data[0]?.checkInTime);

      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "UTC",
      };
      const myData = data?.data?.data?.map((item) => ({
        _id: item._id,
        vehicleRegNumber: item?.vehicleRegNumber,
        vehicleType: item?.vehicleType?.name,
        checkInBy: item?.checkInBy?.boothId?.name,
        name: item?.checkInLoginUser?.firstName,
        checkInTime: item?.checkInTime ?? null,
        checkOutBy: item?.checkOutBy?.boothId?.name,
        checkOutTime: item?.checkOutTime ?? null,

        parkingFee: item?.parkingFee,
        parkedTime: item?.parkedTime,
        site: item?.site?.site,
        exempted: item?.exempted, // 👈 Add this line
      }));
      // Filter out the last item
      const myFilteredData = myData.filter(item => item.exempted === false);

      const totalParkingFee = data?.data?.totalCollection ?? 0;
      setTotalFee(totalParkingFee);
      console.log("Total Collection from API:", data?.data?.totalCollection);
      setDashList(myFilteredData || []);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setDashList([]);   // ✅ Ensure old data is cleared even on error
      setTotalFee(0);    // ✅ Clear total fee
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   if (
  //     formik.values.site !== "" ||
  //     formik.values.boothId !== "" ||
  //     (fromDate !== "" && toDate !== "") ||
  //     selectedUser !== ""
  //   ) {
  //     if (initialized) {
  //       getDashData();
  //     }
  //   }
  // }, [
  //   fromDate,
  //   toDate,
  //   formik.values.boothId,
  //   formik.values.site,
  //   selectedUser,
  //   initialized,
  // ]);
  // console.log("initialized is", initialized)

  const handleDateChange = (e) => {
    setFromDate(e.target.value);
    setInitialized(true);
  };

  const getBoothId = async () => {
    try {
      let apiUrl = `${appUrl.BASE_URL}booth/getBySite`;
      if (siteId) {
        apiUrl += `?siteId=${siteId}`;
      }
      const response = await fetch(apiUrl);
      const data = await response.json();
      setBoothList(data?.data);
      console.log("data", data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (formik.values.site !== null && formik.values.site !== "") {
      getBoothId();
    }
    getSiteList();
  }, [formik.values.site]);
  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Total:" colSpan={8} footerStyle={{ textAlign: "right" }} />
        <Column
          footer={new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR" }).format(totalFee || 0)}
        />
      </Row>
    </ColumnGroup>
  );


  // console.log("Filtered Data (used for frontend total):", myFilteredData);
  const exportExcel = async () => {
    const workbook = XLSX.utils.book_new();
    let exportData = "";

    exportData = dashList?.map((item) => [
      item.vehicleRegNumber,
      item.vehicleType,
      item.site,
      item.checkInBy,
      item.checkInTime,
      item.checkOutBy,
      item.checkOutTime,
      item.parkedTime,
      item.parkingFee,

    ]);

    let lastObj = ["", "", "", "", "", "", "", "", totalFee];
    console.log("lastObj", lastObj);

    let exportData2 = [...exportData, lastObj];
    console.log("exportData2", exportData2);

    const exportHeader = [
      "Vehicle",
      "vehicleType",
      "Site",
      "Check-In Booth",
      "Check-In Time",
      "Check-Out Booth",
      "Check-Out Time",
      "Park Time",
      "Fee",

    ];

    const incWorksheet = XLSX.utils.aoa_to_sheet([
      exportHeader,
      ...exportData2,
    ]);

    XLSX.utils.book_append_sheet(
      workbook,
      incWorksheet,
      "Cash Summary Details"
    );

    // Create a blob and save the file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    saveAsExcelFile(excelBuffer, "cashSummary");
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  console.log("storedLoginRes: ", storedLoginRes);
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site?._id;

  useEffect(() => {
    if (userSite) {
      formik.setFieldValue("site", userSite);
      setSitevalue(userSite);
      setSiteId(userSite);
    }
  }, [userSite]);

  // useEffect(() => {
  //   if (fromDate && toDate) {
  //     getDashData();
  //   }
  // }, [ fromDate, toDate]);

  useEffect(() => {
    getDashData();
  }, []);
  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite);
  }, [userSite, siteList]);
  const filteredBoothList = formik.values.site
    ? dashList.filter((booth) => booth.site?._id === formik.values.site)
    : dashList;

  // const formatParkedTime = (minutes) => {
  //   const hours = Math.floor(minutes / 60);
  //   const remainingMinutes = minutes % 60;

  //   // Pad single-digit minutes with leading zero
  //   const formattedMinutes =
  //     remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes;

  //   return `${hours}:${formattedMinutes}`;
  // };



  const formatParkedTime = (minutes) => {
    if (!minutes && minutes !== 0) return "-";
    return `${minutes} min`;
  };
  return (
    <>
      <div className="p-fluid grid">
        {/* Filter, Search, and Export buttons section */}
        <div className="col-12 flex justify-content-end align-items-center">
          <div className="field">
            <InputText
              className="mbl_view mr-2"
              style={{ borderRadius: "100px" }}
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Search Registration"
            />
          </div>

          <div className="field ml-3">
            <Button
              label={`Filters (${appliedFilters})`}
              icon="pi pi-filter"
              onClick={() => setShowFilters((prevState) => !prevState)}
              style={{
                backgroundColor: showFilters ? "" : "transparent",
                color: showFilters ? "white" : "black",
                boxShadow: "none",
                borderRadius: "100px",
              }}
            />
          </div>

          <div className="field ml-3 rounded-lg">
            <Button
              label="Export to excel"
              type="button"
              style={{ borderRadius: "100px" }}
              icon="pi pi-file-excel"
              severity="success"
              disabled={loading}
              onClick={exportExcel}
              data-pr-tooltip="XLS"
            />
          </div>
        </div>

        {/* Filters section, shown when the user clicks on "Filters" */}
        {showFilters && (
          <div className="flex flex-row flex-wrap gap-3 mt-3 w-full mb-3">
            {/* Site Dropdown */}
            <div className="flex-1 min-w-[200px]">
              <Dropdown
                id="site"
                name="site"
                value={formik.values.site}
                onChange={(e) => {
                  formik.handleChange(e);
                  setSiteId(e.target.value);
                }}
                filter
                filterBy="site"
                filterMatchMode="contains"
                className={classNames(
                  { "p-invalid": isFormFieldValid("site") },
                  "w-full TextArea__Round border-round-3xl"
                )}
                options={siteList}
                optionLabel="site"
                optionValue="_id"
                placeholder="Select Site"
                disabled={!!siteValue && siteValue._id === formik.values.site}
                showClear  
              />
              {getFormErrorMessage("site")}
            </div>

            {/* Booth Dropdown */}
            <div className="flex-1 min-w-[200px]">
              <Dropdown
                id="boothId"
                name="boothId"
                value={formik.values.boothId}
                onChange={(e) => {
                  formik.handleChange(e);
                  setBooothId(e.target.value);
                }}
                filter
                filterBy="boothId"
                filterMatchMode="contains"
                className={classNames(
                  { "p-invalid": isFormFieldValid("boothId") },
                  "w-full TextArea__Round border-round-3xl"
                )}
                options={boothList}
                optionLabel="name"
                optionValue="_id"
                placeholder="Select Booth"
                disabled={loading}
                showClear  
              />
              {getFormErrorMessage("boothId")}
            </div>

            {/* From Date */}
            <div className="flex-1 min-w-[160px]">
              <InputText
                id="fromDate"
                name="fromDate"
                value={fromDate}
                onChange={handleDateChange}
                type="date"
                placeholder="From Date"
                className="w-full border-round-3xl"
                readOnly={loading}
              />
            </div>

            {/* To Date */}
            <div className="flex-1 min-w-[160px]">
              <InputText
                id="toDate"
                name="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                type="date"
                placeholder="To Date"
                className="w-full border-round-3xl"
                readOnly={loading}
              />
            </div>

            {/* Search Button - Align right */}
            <div className="flex justify-content-end align-items-center" style={{ flexGrow: 1 }}>
              <Button
                label="Search"
                icon="pi pi-search"
                className="p-button-rounded p-button-info ml-auto"
                onClick={() => {
                  setInitialized(true);
                  getDashData();
                }}
                disabled={loading}
              />
            </div>
          </div>
        )}

      </div>

      {dashStat === undefined ? (
        <h1>Loading...</h1>
      ) : (
        <div className="grid">
          <div className="col-12 md:col-12">
            <div className="card">
              <div className="flex justify-content-end mb-4"> </div>

              <DataTable
                scrollable
                // scrollHeight="390px"
                emptyMessage="No records found for the selected date"
                rows={10}
                loading={loading}
                filters={filters}
                paginator
                responsiveLayout="scroll"
                value={dashList}
                // value={loading ? dashList : filteredBoothList}
                footerColumnGroup={footerGroup}
                // key="_id"
                globalFilterFields={["vehicleRegNumber"]}
              >
                <Column
                  header="ID"
                  body={(rowData) => (
                    <div title={rowData._id} style={{ cursor: "pointer" }}>
                      {`${rowData._id?.slice(0, 6)}...${rowData._id?.slice(
                        -6
                      )}`}
                    </div>
                  )}
                />
                <Column field="site" header="Site Name" />
                <Column field="vehicleType" header="Vehicle" />
                <Column field="vehicleRegNumber" header="Registration" />
                <Column
                  field="checkInTime"
                  header="Check-In"
                  body={(rowData) => {
                    if (!rowData.checkInTime) return '-';
                    return moment.utc(rowData.checkInTime).format("hh:mm:ss A YYYY-MM-DD ");
                  }}
                />

                <Column field="checkInBy" header="Check-In Booth" />

                <Column
                  field="checkOutTime"
                  header="Check-Out"
                  body={(rowData) => {
                    if (!rowData.checkOutTime) return '-';
                    return moment.utc(rowData.checkOutTime).format("hh:mm:ss A YYYY-MM-DD ");
                  }}
                />

                <Column field="checkOutBy" header="Check-Out Booth" />
                <Column
                  field="parkingFee"
                  header="Parking Fee"
                  body={(rowData) =>
                    new Intl.NumberFormat("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    }).format(rowData.parkingFee)
                  }
                />
                <Column
                  field="parkedTime"
                  header="Park Time"
                  body={(rowData) => formatParkedTime(rowData.parkedTime)}
                />
              </DataTable>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CashSummary;
